// interlinked-tdd: exempt
// Curated MCP server catalog — Clinical portal. Hand-maintained data; add new
// servers here. Split out of curated-servers.ts to stay under the file-size cap.
import type { CuratedServer } from "./types";

export const CLINICAL_SERVERS: CuratedServer[] = [
  {
    key: "cdc",
    name: "CDC Open Data",
    type: "streamable-http",
    url: "https://cdc-open-data-mcp-server.quentincody.workers.dev/mcp",
    description: "CDC Open Data via Socrata SODA API — 1100+ public health datasets covering disease surveillance, mortality…",
    theme: "clinical",
    category: "phenotype & disease",
    defaultEnabled: true,
  },
  {
    key: "clinical-guidelines",
    name: "Clinical Guidelines",
    type: "streamable-http",
    url: "https://clinical-guidelines-mcp-server.quentincody.workers.dev/mcp",
    description: "USPSTF screening recommendations, CDC immunization schedules, AHRQ CDS Connect — preventive care guidelines",
    theme: "clinical",
    category: "trials & immunology",
    defaultEnabled: true,
  },
  {
    key: "cms-drug-pricing",
    name: "CMS Drug Pricing",
    type: "streamable-http",
    url: "https://cms-drug-pricing-mcp-server.quentincody.workers.dev/mcp",
    description: "NADAC weekly drug acquisition costs + Medicaid state drug utilization data from data.medicaid.gov",
    theme: "clinical",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "cms-formulary",
    name: "CMS Formulary",
    type: "streamable-http",
    url: "https://cms-formulary-mcp-server.quentincody.workers.dev/mcp",
    description: "Medicare Part D formulary and pharmacy data — plan-level drug coverage, prior authorization, step therapy, and…",
    theme: "clinical",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "cms-partd",
    name: "CMS Part D",
    type: "streamable-http",
    url: "https://cms-partd-mcp-server.quentincody.workers.dev/mcp",
    description: "Medicare Part D prescriber-level drug data + annual/quarterly drug spending from data.cms.gov",
    theme: "clinical",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "cms-pricing",
    name: "CMS Medicare Pricing",
    type: "streamable-http",
    url: "https://cms-pricing-mcp-server.quentincody.workers.dev/mcp",
    description: "Medicare procedure pricing — inpatient DRG, outpatient APC, physician HCPCS, DMEPOS, lab, drug spending, and…",
    theme: "clinical",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "cms-provider",
    name: "CMS Provider Data",
    type: "streamable-http",
    url: "https://cms-provider-mcp-server.quentincody.workers.dev/mcp",
    description: "CMS Provider Data — clinician lookup, nursing home ratings/quality/staffing/penalties, hospital star ratings…",
    theme: "clinical",
    category: "healthcare & claims",
    defaultEnabled: true,
  },
  {
    key: "datacite",
    name: "DataCite",
    type: "streamable-http",
    url: "https://datacite-mcp-server.quentincody.workers.dev/mcp",
    description: "DataCite PID Graph - resolve DOIs and discover related research outputs, authors, funders, and organizations",
    theme: "clinical",
    category: "literature & data",
    defaultEnabled: true,
  },
  {
    key: "ebi-tools",
    name: "EBI Job Dispatcher",
    type: "streamable-http",
    url: "https://ebi-tools-mcp-server.quentincody.workers.dev/mcp",
    description: "EMBL-EBI bioinformatics tools — BLAST, Clustal Omega, InterProScan, reverse translation (backtranseq), signal…",
    theme: "clinical",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "entrez",
    name: "Entrez",
    type: "streamable-http",
    url: "https://entrez-mcp-server.quentincody.workers.dev/mcp",
    description: "NCBI Entrez system for accessing a variety of biological databases",
    theme: "clinical",
    category: "literature & data",
    defaultEnabled: true,
  },
  {
    key: "federal-register",
    name: "Federal Register",
    type: "streamable-http",
    url: "https://federal-register-mcp-server.quentincody.workers.dev/mcp",
    description: "Federal Register public API for document search, agency lookup, and public inspection records",
    theme: "clinical",
    category: "public health",
    defaultEnabled: true,
  },
  {
    key: "fhir",
    name: "FHIR R4",
    type: "streamable-http",
    url: "https://fhir-mcp-server.quentincody.workers.dev/mcp",
    description: "FHIR R4 clinical data — patients, conditions (ICD-10), medications (RxNorm), labs (LOINC), encounters…",
    theme: "clinical",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "funding-graph",
    name: "Funding Graph",
    type: "streamable-http",
    url: "https://funding-graph-mcp-server.quentincody.workers.dev/mcp",
    description: "Funding graph over NIH RePORTER, NSF Award Search, CORDIS DET, and USAspending for awards, projects, agencies…",
    theme: "clinical",
    category: "literature & data",
    defaultEnabled: true,
  },
  {
    key: "icd10-codes",
    name: "ICD-10 Codes",
    type: "streamable-http",
    url: "https://icd10-codes-mcp-server.quentincody.workers.dev/mcp",
    description: "ICD-10 diagnosis and procedure code lookup, search, validation, and hierarchy navigation",
    theme: "clinical",
    category: "clinical & ontology",
    defaultEnabled: true,
  },
  {
    key: "loinc",
    name: "LOINC",
    type: "streamable-http",
    url: "https://loinc-mcp-server.quentincody.workers.dev/mcp",
    description: "LOINC terminology — 99K+ lab/observation codes via FHIR R4 terminology service. Code lookup, validation, value…",
    theme: "clinical",
    category: "clinical & ontology",
    defaultEnabled: true,
  },
  {
    key: "medcalc",
    name: "MedCalc",
    type: "streamable-http",
    url: "https://medcalc-mcp-server.quentincody.workers.dev/mcp",
    description: "Clinical calculators — eGFR (CKD-EPI 2021), MELD/MELD-Na, CHA₂DS₂-VASc, Wells DVT/PE, BMI, corrected calcium…",
    theme: "clinical",
    category: "clinical & ontology",
    defaultEnabled: true,
  },
  {
    key: "npi-registry",
    name: "NPI Registry",
    type: "streamable-http",
    url: "https://npi-registry-mcp-server.quentincody.workers.dev/mcp",
    description: "US National Provider Identifier Registry - healthcare provider lookup, validation, and search",
    theme: "clinical",
    category: "healthcare & claims",
    defaultEnabled: true,
  },
  {
    key: "nucc-taxonomy",
    name: "NUCC Taxonomy",
    type: "streamable-http",
    url: "https://nucc-taxonomy-mcp-server.quentincody.workers.dev/mcp",
    description: "NUCC Health Care Provider Taxonomy — 900+ provider specialty codes used in NPI Registry. Search by specialty…",
    theme: "clinical",
    category: "healthcare & claims",
    defaultEnabled: true,
  },
  {
    key: "oig-leie",
    name: "OIG LEIE",
    type: "streamable-http",
    url: "https://oig-leie-mcp-server.quentincody.workers.dev/mcp",
    description: "OIG List of Excluded Individuals/Entities — healthcare provider exclusion screening, monthly compliance checks",
    theme: "clinical",
    category: "healthcare & claims",
    defaultEnabled: true,
  },
  {
    key: "ontology-hub",
    name: "Ontology Hub",
    type: "streamable-http",
    url: "https://ontology-hub-mcp-server.quentincody.workers.dev/mcp",
    description: "QuickGO + OLS4 — GO term lookup and annotations, cross-ontology search (GO, HPO, MONDO, NCIT), term hierarchies",
    theme: "clinical",
    category: "cancer",
    defaultEnabled: true,
  },
  {
    key: "openpayments",
    name: "Open Payments",
    type: "streamable-http",
    url: "https://openpayments-mcp-server.quentincody.workers.dev/mcp",
    description: "CMS Open Payments — manufacturer/GPO payments to physicians and teaching hospitals (2018-2024)…",
    theme: "clinical",
    category: "healthcare & claims",
    defaultEnabled: true,
  },
  {
    key: "patentsview",
    name: "EPO Patents",
    type: "streamable-http",
    url: "https://patentsview-mcp-server.quentincody.workers.dev/mcp",
    description: "EPO patent data — bibliographic records, INPADOC family + legal status, EP/WO full text. The /lod/* endpoints need no credential; OPS search needs EPO_OPS_KEY + EPO_OPS_SECRET.",
    theme: "clinical",
    category: "literature & data",
    defaultEnabled: true,
  },
  {
    key: "patient-education",
    name: "Patient Education",
    type: "streamable-http",
    url: "https://patient-education-mcp-server.quentincody.workers.dev/mcp",
    description: "MedlinePlus Connect (health topics by ICD-10/LOINC/NDC) + DailyMed (drug labels, pill identification)",
    theme: "clinical",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "pubtator",
    name: "PubTator3",
    type: "streamable-http",
    url: "https://pubtator-mcp-server.quentincody.workers.dev/mcp",
    description: "NCBI PubTator3 — NLP entity annotations on PubMed articles. Genes, variants, diseases, chemicals, species…",
    theme: "clinical",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "scholarly-graph",
    name: "Scholarly Graph",
    type: "streamable-http",
    url: "https://scholarly-graph-mcp-server.quentincody.workers.dev/mcp",
    description: "Scholarly graph over OpenAlex, Crossref, ORCID, ROR, and OpenAIRE for works, authors, organizations, funders…",
    theme: "clinical",
    category: "literature & data",
    defaultEnabled: true,
  },
  {
    key: "snowstorm",
    name: "SNOMED CT (Snowstorm)",
    type: "streamable-http",
    url: "https://snowstorm-mcp-server.quentincody.workers.dev/mcp",
    description: "SNOMED CT terminology — concept lookup, hierarchy navigation, ECL queries, ICD-10 mappings via IHTSDO Snowstorm",
    theme: "clinical",
    category: "clinical & ontology",
    defaultEnabled: true,
  },
  {
    key: "who-icd11",
    name: "WHO ICD-11",
    type: "streamable-http",
    url: "https://who-icd11-mcp-server.quentincody.workers.dev/mcp",
    description: "WHO ICD-11 — International Classification of Diseases 11th Revision. Entity search, linearization coding…",
    theme: "clinical",
    category: "clinical & ontology",
    defaultEnabled: true,
  },
  {
    key: "europepmc",
    name: "Europe PMC",
    type: "streamable-http",
    url: "https://europepmc-mcp-server.quentincody.workers.dev/mcp",
    description: "Europe PMC — open-access biomedical literature: search 45M+ abstracts, OA full-text (JATS XML), text-mined annotations, citations, and cross-links",
    theme: "clinical",
    category: "literature & data",
    defaultEnabled: true,
  },
  {
    key: "cms-coverage",
    name: "CMS Coverage",
    type: "streamable-http",
    url: "https://cms-coverage-mcp-server.quentincody.workers.dev/mcp",
    description: "CMS Coverage — Medicare National and Local Coverage Determinations (NCD/LCD): what Medicare covers, under which conditions, and the supporting evidence.",
    theme: "clinical",
    category: "healthcare policy",
    defaultEnabled: true,
  },
  {
    key: "medical-coding",
    name: "Medical Coding",
    type: "streamable-http",
    url: "https://medical-coding-mcp-server.quentincody.workers.dev/mcp",
    description: "Medical Coding — HCPCS/CPT-style procedure and billing code lookup and cross-referencing for claims and coverage work.",
    theme: "clinical",
    category: "clinical & ontology",
    defaultEnabled: true,
  },
];
